// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-login-reminder {
  position: sticky;
  top: 56px;
  z-index: 1000;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/login-reminder/login-reminder.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AACF","sourcesContent":[".banner-login-reminder {\n  position: sticky;\n  top: 56px;\n  z-index: 1000;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
